import {
  provideHttpClient,
  withFetch,
  withInterceptors
} from '@angular/common/http'
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from '@angular/core'
import {provideRouter, withHashLocation} from '@angular/router'
import {LOCAL_STORAGE} from './0-general/providers'
import {authInterceptor} from './1-application/auth.interceptor'
import {responseInterceptor} from './1-application/response.interceptor'
import {routes} from './app.routes'
import {ConfigService} from './services/config.service'

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCAL_STORAGE, useValue: localStorage},
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}
